import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, DialogContentText } from '@material-ui/core';
import Input from '../../Input/Input';
import { format } from 'date-fns';

function CustomDialog({ open, onClose, data, tableState }) {
    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            PaperProps={{
                style: {
                    borderRadius: 20,
                },
            }}
        >
            {
                !tableState.confirmDemission ? (
                    <>
                        <DialogTitle style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                Desligamento de {data.row.name ? data.row.name : ''}
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>O funcionário não poderá realizar marcações de ponto e nem acessar suas informações após o último dia de trabalho.</DialogContentText>
                            <div style={{ display: 'flex' }}>
                                <Input
                                    elementType="datePicker"
                                    style={{ marginRight: '40px' }}
                                    label="Data da demissão"
                                    margin="normal"
                                    value={tableState.demissionDate || null}
                                    onChange={event => tableState.handleChangeDemission('demissionDate', event)}
                                // disabled={this.state.currentItem && this.state.currentItem.isFired}
                                />

                                <div style={{ marginLeft: 'auto' }}>
                                    <Input
                                        elementType="datePicker"
                                        label="Último dia de trabalho"
                                        margin="normal"
                                        value={tableState.lastWorkingDay || null}
                                        // minDate={startDate}
                                        minDateMessage="Não pode ser anterior à data da demissão"
                                        onChange={event => tableState.handleChangeDemission('lastWorkingDay', event)}
                                    // disabled={this.state.currentItem && this.state.currentItem.isFired}
                                    />
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                style={{ margin: 'auto' }}
                                // disabled={!isValid(startDate) || !isValid(endDate)}
                                onClick={() => tableState.setConfirmDemission(true)}
                                variant="contained"
                                color="primary"
                                autoFocus
                            >
                                {/* {this.state.currentItem && this.state.currentItem.isFired ? 'CANCELAR DESLIGAMENTO' : 'DESLIGAR'} */}
                                DESLIGAR
                            </Button>
                        </DialogActions>
                    </>
                )
                    :
                    <>
                        <DialogTitle>{!tableState.confirmDemission ? 'Cancelar' : 'Confirmar'}  Desligamento de {data.row.name ? data.row.name : ''}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {
                                    !tableState.confirmDemission ?
                                        'Deseja cancelar o desligamento previsto para as seguintes datas:' :
                                        'Deseja confirmar o desligamento nas seguintes datas:'
                                }
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <span>demissão - {format(tableState.demissionDate, 'dd/MM/yyyy')}</span>
                                    <span style={{ marginLeft: '40px' }}>último dia - {format(tableState.lastWorkingDay, 'dd/MM/yyyy')}</span>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => tableState.setConfirmDemission(false)}>CANCELAR</Button>
                            <Button onClick={tableState.demissionEmployee} variant="contained" color="primary" autoFocus>
                                CONFIRMAR
                            </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>

    );
}

export default CustomDialog;
